<template>
  <!-- 广告组件（统一入口） -->
  <div class="adBox">
    <!-- 云纵 -->
    <ad-yunzong v-if="currentFlag === '1' && currentId" :urls="currentId"></ad-yunzong>
    <!-- 伯斯特 -->
    <ad-bosite v-if="currentFlag === '2' && currentId"></ad-bosite>
    <!-- P云 -->
    <ad-pcloud v-if="currentFlag === '3' && currentId" :spaceId="currentId"></ad-pcloud>
    <!-- 群蜂 -->
    <ad-qunfeng v-if="currentFlag === '4' && currentId" :positionId="currentId"></ad-qunfeng>
  </div>
</template>
<script>
import * as util from '../../config/envsetting'
import { AD_POSITIONS } from '../../config/adConfig'
import AdBosite from './ads/ad_bosite.vue'
import AdYunzong from './ads/ad_yunzong.vue'
import AdPcloud from './ads/ad_pcloud.vue'
import AdQunfeng from './ads/ad_qunfeng.vue'

export default {
  name: 'advertising',
  components: { AdYunzong, AdBosite, AdPcloud, AdQunfeng },
  props: {
    // 云纵/伯斯特的广告位ID（直接传入，兼容旧用法）
    urls: {
      type: String,
      default: ''
    },
    // 广告位标识（使用 adConfig 中的 key，如 'HOME_BANNER'）
    // 优先级：position > urls
    position: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentFlag: '',
      currentId: ''
    }
  },
  mounted () {
    this.currentFlag = util.adFlag

    if (this.position && AD_POSITIONS[this.position]) {
      // 使用统一配置
      const pos = AD_POSITIONS[this.position]
      const flagMap = { 1: 'yunzong', 2: 'bosite', 3: 'pcloud', 4: 'qunfeng' }
      const sourceKey = flagMap[this.currentFlag] || 'yunzong'
      this.currentId = pos[sourceKey] || ''
      console.log('[Adver] position:', this.position, 'flag:', this.currentFlag, 'id:', this.currentId)
    } else {
      // 兼容旧用法：直接传 urls
      this.currentId = this.urls
      console.log('[Adver] urls:', this.urls, 'flag:', this.currentFlag)
    }
  }
}
</script>

<style scoped>
.adBox {
  width: 100%;
  height: 100%;
}
</style>
